import { Font } from '@react-pdf/renderer';

// 自己ホストの Noto Sans JP (WOFF) — 日本語PDF用フォント。
// 同一オリジン配信のためCDNより高速・確実で、ブラウザHTTPキャッシュにも残る。
// @react-pdf は woff2 非対応のため woff を使用。1ファイルのみ登録して全ウェイトで共用し、
// 解析回数を1回に抑える（太字スタイルは最も近いこのフォントに解決される）。
const FONT_URL = '/fonts/noto-sans-jp-400.woff';

// ブラウザでのみ自己ホストパスで登録する。Node（検証ハーネス等）では document が無いので
// ここでは登録せず、呼び出し側がファイルパスで Font.register する想定（同一 family 名で共用）。
if (typeof document !== 'undefined') {
  Font.register({ family: 'NotoSansJP', src: FONT_URL });
}

// 連続文字の途中でも折り返せるようにし、CJKの行折り返しでの再計算コストを抑える
Font.registerHyphenationCallback((word) => [word]);

export const FONT_FAMILY = 'NotoSansJP';
